module.exports = __webpack_public_path__ + "assets/img/index_plat_three.bf33eaad.png";